import { Component } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { ForgotPasswordDialogComponent } from './forgot-password-dialog/forgot-password-dialog.component'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { FormGroupState } from 'ngrx-forms'
import { ChangePasswordValues, selectProfileState } from '../user-profile.state'

@Component({
  selector: 'cover-user-access-data',
  templateUrl: './user-access-data.component.html',
  styleUrls: ['./user-access-data.component.scss'],
})
export class UserAccessDataComponent {
  formState$: Observable<FormGroupState<ChangePasswordValues>>
  passwordIsHidden: boolean = true
  repeatPasswordIsHidden: boolean = true

  constructor(private readonly dialog: MatDialog, private readonly store: Store) {
    this.formState$ = store.select(selectProfileState.changePasswordControls)
  }

  onForgotPassword(): void {
    this.dialog.open(ForgotPasswordDialogComponent)
  }
}
